import {
  ChangeDetectionStrategy, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output,
  ViewContainerRef, ViewEncapsulation
} from '@angular/core';
import {TranslateService} from "@ngx-translate/core";
import {environment} from "../../../../../environments/environment";
import {ConnectedPosition, Overlay, OverlayRef} from "@angular/cdk/overlay";
import {ComponentPortal} from "@angular/cdk/portal";
import {QuickActionsMenuComponent} from "../quick-actions-menu/quick-actions-menu.component";
import {ProjectCardModel} from "../../models/project-card.model";
import {BehaviorSubject} from "rxjs";

@Component({
  selector: 'app-project-cards',
  templateUrl: './project-cards.component.html',
  styleUrls: ['./project-cards.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProjectCardsComponent implements OnInit {
  @Input() projectCards: any[] = [];
  @Input() projectDefaultCategories: any[] = [];
  @Input() set filterByIndicator(value: any) {
    this.selectedIndicator = value;
  };
  @Input() set sortByFilter(value: any) {
      this.selectedRadioButton = value ? this.radioButtons.find((btn: any) => btn.value === value) : this.radioButtons[1];
  };
  @Input() set quickActionData(value: any) {
    this.menuDataSubject.next(value);
  };

  @Output() sortByChange = new EventEmitter<any>();
  @Output() indicatorSortEvent = new EventEmitter<any>();
  @Output() loadQuickActionMenuData = new EventEmitter<any>();

  private readonly menuDataSubject = new BehaviorSubject<any | null>(null);
  readonly menuData$ = this.menuDataSubject.asObservable();

  selectedRadioButton: any;
  selectedIndicator: any;
  selectedProjectCard: any | null = null;

  baseUrl!: string;

  radioButtons: any[] = [
    {label: this.translate.instant('team_overview_high'),slug: 'highest', id: 'radio1', value: 'DESC'},
    {label: this.translate.instant('team_overview_low'),slug: 'lowest', id: 'radio2', value: 'ASC'}];

  constructor(
    private translate: TranslateService,
    private cdr: ChangeDetectorRef) { }

  ngOnInit(): void {
    this.baseUrl = environment.baseUrl;
  }

  setFilterByScore() {
    this.sortByChange.emit(this.selectedRadioButton?.value);
  }

  changeIndicator(indicator: any) {
    this.indicatorSortEvent.emit(indicator);
  }

  openQuickActionsMenu(cardProject: any) {
    this.selectedProjectCard = cardProject;
    this.loadQuickActionMenuData.emit(cardProject.project.uuid);
  }

}
